import React, {useEffect, useState, useRef} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {Box, CircularProgress,  Typography} from '@mui/material';
import * as allConstants from '../../../../../constants/allConstants';
import AllJobsGrid from '../../../allJobs/allJobsGrid';
import DisplayListsPageWrapper from '../../../../wrappers/displayListsPageWrapper';
import ListPageHeader from '../../../../../pieces/listPageHeader';
import usePagination from '../../../../../hooks/usePagination';
import {JobJSON, DevHandleAlerts} from '../../../allJobs/devJobView';
import ModalWrapper from '../../../../../pieces/modals/modalWrapper';
import JobDetailView from '../../../jobDetails/views/jobDetailView';
import {jobApiTypes} from '../../../helpers/jobGridOptions';
import mergeProps from 'merge-props';
import {useGridViewState} from '../../../../../hooks/useGridViewState';
import Utils from '../../../../../utils/utils';
import {useSelector} from 'react-redux';
import {companyAndUserUtils} from '../../../../../utils/companyAndUserUtils';
import {IPERMIT_ROLES} from '../../../../../constants/roles';
import {useFilter, GridWithFilterWrapper} from '../../../../../hooks/useFilter';
import {jobFilters} from '../../../allJobs/jobExtendedFilters';
import useViewMenu, {MenuOption} from '../../../../../hooks/useViewMenu';
import {ListViewHeader} from '../../../components/listViewHeader';
import base_url, {urlSearchParams} from '../../../../../baseUrls';
import {isContractor, isImpersonating} from '../../../../../permissions/utils';
import {NewPermissionGate} from '../../../../../permissions/permissionGate';
import {ADMIN_ELEMENTS, ipermitAdminRules} from '../../../../../permissions/ipermitAdminAccessControl';
import axios from 'axios';
import ApiUtils from '../../../../../utils/apiUtils';
import {useGotIt} from '../../../../../hooks/useGotIt';
import ManageCustomViews from '../../../components/manageCustomViews';
import {toast} from 'react-toastify';


const AllPermitJobsView = (props) => {

  //console.log('inside allpermitjobsview');
  //console.log(props);

  
  const viewController = useGridViewState();
  const navigate = useNavigate();
  const initialSelectedJob = Utils.getUrlParameter('job');
  const [selectedJob, setSelectedJob] = useState(initialSelectedJob);
  const [isLoading, setIsLoading ] = useState(false);

  const [crudAction, setCrudAction] = useState();
  const [isCategory, setIsCategory] = useState();   //useState(false);
  const [customViewVisible, setCustomViewVisible] = useState(); // useState(false);
  const [showDevJobDetails, setShowDevJobDetails] = useState(); // useState(false);
  const [showDevZohoAlertHandler, setshowDevZohoAlertHandler] = useState(false);
  const pagination = usePagination();
  const [searchParams, setSearchParams] = useSearchParams();
  const [allowScrollModal, setAllowScrollModal] = useState(true);
  const company = useSelector(state => state.company);
  const user = useSelector(state=> state.user);
  const userRole = user[allConstants.USER_FIELDS.ROLE.api_name];
  const isHers = Object.values(IPERMIT_ROLES).includes(userRole)|| companyAndUserUtils.isHERSCompany(company);
  const isEuc =  Object.values(IPERMIT_ROLES).includes(userRole) || companyAndUserUtils.isEUCCompany(company);
  const isTestingOnly =companyAndUserUtils.isTestingOnlyCompany(company);
  const gotItPopup = useGotIt();
  const filterFields = jobFilters.getFilters(user);

  //const [createdFromDate, setCreatedFromDate] = useState(null);
  //const [globalFilters, setGlobalFilters] = useState({});
  const [globalSearchFilters, setGlobalSearchFilters] = useState({});
  //const globalSearchFiltersRef2 = useRef({});

  const extendedFilters = useFilter({fields: filterFields, width: 230, collection: 'jobs'});

  // useEffect ( () => {

  //   if (!isContractor(userRole)) {
  //     const oneYearAgo = new Date();
  //     oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  //     //oneYearAgo.setMonth(oneYearAgo.getMonth() - 6);

  //     setCreatedFromDate(oneYearAgo.toISOString().split('T')[0]);

  //     //console.log('inside use efferct set global filter');

  //     const filters = {"createdAt":{"dateFrom": oneYearAgo.toISOString().split('T')[0] ,"dateTo":null,"filterType":"date","type":"greaterThanOrEqual"}};
  //     setGlobalFilters(filters);
  //     viewController.setGlobalFilters(filters);
  //   }
  // },[]);

  const getMenuItems = ()=> {
    const items = [new MenuOption(jobApiTypes.all, 'All Jobs')];
    items.push(new MenuOption(jobApiTypes.unreadNote, "Unread Notes"));
    
    if(!isTestingOnly && (isHers || isEuc)) {
      items.push(new MenuOption(jobApiTypes.permits, 'Permit Jobs'));
    }
    if((isHers && !isTestingOnly)||isEuc) {
      items.push( new MenuOption(jobApiTypes.hers, 'HERS Jobs'));
    }
    if(isEuc) {
      items.push( new MenuOption(jobApiTypes.euc, 'EUC Jobs'));
    }
    items.push( new MenuOption(jobApiTypes.inspections, 'Inspections'));
    items.push( new MenuOption(jobApiTypes.drafts, 'Drafts'));
    items.push( new MenuOption(jobApiTypes.archivedDrafts, 'Archived Drafts'));
    if(process.env.NODE_ENV === 'development' || NewPermissionGate({
      user: user,
      elementPermissions: ipermitAdminRules[ADMIN_ELEMENTS.forceSyncWithCRM],
    })) {
      items.push( new MenuOption(jobApiTypes.zohoUnsynced, 'Zoho Unsynced Jobs'));
    }
    items.push( new MenuOption(jobApiTypes.report, 'Report for Export'));
    return items;
  };
  const JobGridEnum = getMenuItems();

  const menuController = useViewMenu({items: JobGridEnum});

  const handleShowJobClose = () => {
    setSelectedJob(undefined);
  };

  const handleClick = (event) => {
    menuController.setAnchorEl(event.currentTarget);
  };

  const viewJobHandler = (id)=> {

    //console.log('insdie view Job handler');

    if (!id || id === '') {
      return;
    }

    // Open immediately while still in the user gesture stack. Any await before window.open
    // lets the browser treat the new tab as a popup and block or defer it intermittently.
    const jobUrl = `${location.origin}${location.pathname}/${id}${location.search}`;
    window.open(jobUrl, '_blank');

    void (async () => {
      const markReadUrl = `${base_url.api}jobs/mark-note-read-for-job`;
      const requestParams = {jobId: id, isForContractor: false};
      try {
        const authToken = await ApiUtils.getAccessToken();
        await axios.post(markReadUrl, JSON.stringify(requestParams), {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: authToken,
          },
        });
      } catch (_e) {
        // non-blocking: tab already opened
      }
    })();

    //navigate(`${id}${location.search}`);
  };

  const devViewJobOpen = (id)=> {
    setSelectedJob(id);
    setShowDevJobDetails(true);
  };
  const devAlertJobOpen = (id)=> {
    setSelectedJob(id);
    setshowDevZohoAlertHandler(true);
  };
  const devViewJobClose = (id)=> {
    setSelectedJob(null);
    if(showDevJobDetails) {
      setShowDevJobDetails(false);
    } else if(showDevZohoAlertHandler) {
      setshowDevZohoAlertHandler(false);
    }

  };

  const gridProps = {
    devViewJobHandler: devViewJobOpen,
    crmAlertHandler: devAlertJobOpen,
    viewJobHandler: viewJobHandler,
    pagination: pagination,
    viewController: viewController,

  };

  const changeView = () => {
    const job = searchParams.get('job');
    if (job) { viewJobHandler(job); }
  };

  const getFilterParamsFromURL = ()=> {
    if(searchParams.get([allConstants.JOB_FIELDS.PERMIT_STATUS.api_name])) {
      return [allConstants.JOB_FIELDS.PERMIT_STATUS.api_name, searchParams.get([allConstants.JOB_FIELDS.PERMIT_STATUS.api_name])];
    } else if(searchParams.get([allConstants.JOB_FIELDS.HERS_STATUS.api_name])) {
      return [allConstants.JOB_FIELDS.HERS_STATUS.api_name, searchParams.get([allConstants.JOB_FIELDS.HERS_STATUS.api_name])];
    }
    return undefined;
  };

  const defFilterParams = getFilterParamsFromURL();

  useEffect(()=> {

    //console.log('inside useeffect - selectedjob');

    if(selectedJob) {

      console.log('job exist');
      setSearchParams(Utils.createQueryParam(location, {job: selectedJob}));

    } else {

      //console.log('delte job');

      searchParams.delete('job');
      searchParams.delete('tab');
      setSearchParams(searchParams);
    }
  }, [selectedJob]);

  useEffect(() => {
    changeView();
  }, []);

  useEffect(()=> {
    searchParams.set(urlSearchParams.view, JobGridEnum[menuController.viewGrid].value);
    if(menuController?.title?.toLowerCase() !== jobApiTypes.inspections){
      searchParams.delete(urlSearchParams.failedInspections);

    }
    setSearchParams(searchParams);
  }, [menuController.title]);


  const toggleFailedInspections = (event) => {
    const failedInspections = searchParams.get(urlSearchParams.failedInspections);
    if (failedInspections) {
      searchParams.delete(urlSearchParams.failedInspections);
    } else {
      searchParams.set(urlSearchParams.failedInspections, true);
    }
    setSearchParams(searchParams);
  };

  const shouldHideFilters = ()=> {

    if(!isContractor(userRole) && !isImpersonating(userRole, viewController.companyId)) {
      return false;
    }
    // temporary hide advanced inspections filters for contractors
    return menuController.viewGrid === 4;
  };

  // const createdFromDateChange = (newDate) => {
  //   setCreatedFromDate((new Date(newDate)).toISOString().split('T')[0]);
  // };

  const turnOffSearch = () => {
    //console.log('turn off search');

    setGlobalSearchFilters({});
    //globalSearchFiltersRef2.current = {};
  };

  const createFilterForSearchText = (searchText) => {
 
    //console.log('inside create filter for search ');

    const minJobNum = 1000000;
    let jobNum =  (/^\d+$/.test(searchText)) ? parseInt(searchText) : minJobNum;

    if (jobNum < minJobNum) 
      jobNum = minJobNum;

    const filters = {"homeOwner.firstName": {"filterType":"text","type":"contains","filter": searchText}, 
                "company.name": {"filterType":"text","type":"contains","filter": searchText},
                jobNumber: {"filterType":"number","type":"equals","filter": jobNum},
                "address.line1": {"filterType":"text","type":"contains","filter": searchText},
                "assignedCity.name": {"filterType":"text","type":"contains","filter": searchText},
                serviceTitanJobNumber: {"filterType":"text","type":"contains","filter": searchText},
                // customerJobNumber:  {"filterType":"text","type":"contains","filter": searchText},
              };
    setGlobalSearchFilters(filters);

    //console.log('search filter');
    //console.log(filters);

    //globalSearchFiltersRef2.current = filters;
  }

  // useEffect ( () => {
        
  //   //console.log('inside useEffect - createdFromDate changed');

  //   if (!isContractor(userRole)) {
  //     const filters = {"createdAt":{"dateFrom": createdFromDate ,"dateTo":null,"filterType":"date","type":"greaterThanOrEqual"}};
  //     setGlobalFilters(filters);
  //     viewController.setGlobalFilters(filters);
  //   }
  // }, [createdFromDate])

  // useEffect ( () => {
  //   refreshGrid();
  // }, [globalFilters])

  const refreshGrid = () => {
    viewController.refreshGrid();
  };

  const handleExpireDrafts = async () => {
    const payload = {};
    if (isContractor(userRole) || isImpersonating(userRole, viewController.companyId)) {
      payload.companyId = viewController.companyId;
    }
    setIsLoading(true);
    try {
      const response = await ApiUtils.makeApiCall('POST', '/jobs/expire-drafts', JSON.stringify(payload));
      if (response?.status === 'success') {
        toast.success(`${response.data.expiredCount} draft(s) older than 6 months have been deleted.`, {toastId: 'expire_drafts_success'});
        refreshGrid();
      } else {
        toast.error(response?.message || 'Failed to expire drafts.', {toastId: 'expire_drafts_error'});
      }
    } catch (e) {
      toast.error('An error occurred while expiring drafts.', {toastId: 'expire_drafts_error'});
    } finally {
      setIsLoading(false);
    }
  };


  const getHeaderComponent = ()=> {
    let title = menuController.title;

    const exportToExcelViaEmail = (title?.toLowerCase() === jobApiTypes.inspections || 
                        title?.toLowerCase() === jobApiTypes.report) ? false: true;

    if(title?.toLowerCase() === jobApiTypes.inspections) {
      //modify title for inspections
      const isFailedOnly = searchParams.get(urlSearchParams.failedInspections);
      title = `${isFailedOnly ? 'Failed ' : 'All'} ${title}`;
    }
    if(pagination.totalItemsCount) {
      title = `${title} (${pagination.totalItemsCount})`;
    }


    return (
      <ListViewHeader title={title}
        // createdFromDate={createdFromDate}
        // createdFromDateChange={createdFromDateChange}
        gridEnum={JobGridEnum}
        pagination={pagination}
        handleClick={handleClick}
        menuController={menuController}
        extendedFilters={shouldHideFilters() ? null : extendedFilters}
        viewController={viewController}
        showCustomView={showCustomView}
        changeCurrentView = {changeCurrentView}
        sendEmail={exportToExcelViaEmail}
        totalItemsCount={pagination.totalItemsCount}
      />
    );
  };


  const getNewTenantJobs = async () => {

    setIsLoading(true);

    const url = `${base_url.api}companies/get-tenant-jobs-manually`;
    
    let requestParams = { tenantId: company.serviceTitan?.tenantId ?? 0,
                          id: 0 };

    const authToken = await ApiUtils.getAccessToken(); 

    let axiosConfig = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: authToken,
      }
    };
    await axios.post(url, JSON.stringify(requestParams), axiosConfig);
    
    setIsLoading(false);
    gotItPopup.setShow(`Please wait for a minute or two and click on "Refresh Grid" button to see new jobs`);


  }
  const getAdditionalButtons = ()=> {

    let buttons = [];

    if(menuController.title?.toLowerCase() === jobApiTypes.inspections) {
      buttons.push(
        {
          key: 1,
          label: `${searchParams.get(urlSearchParams.failedInspections) ? 'All Inspections' : 'Failed Only' }`,
          variant: 'outlined',
          color: `${searchParams.get(urlSearchParams.failedInspections) ? 'primary' : 'secondary' }`,
          onClick: toggleFailedInspections,
        }
      );
    }

    //console.log('company info - permit view');
    //console.log(company);

    // if (company.serviceTitan?.tenantId != null) {
    //   buttons.push(
    //     {
    //       key: 2,
    //       label: `Get New Jobs`,
    //       variant: 'outlined',
    //       color: 'primary',
    //       onClick: getNewTenantJobs,
    //     },
    //   );  
    // };
    if (menuController.title?.toLowerCase() === jobApiTypes.drafts) {
      buttons.push({
        key: 4,
        label: 'Clear Old Drafts',
        variant: 'outlined',
        color: 'warning',
        tooltip: 'Delete drafts older than 6 months',
        onClick: handleExpireDrafts,
      });
    }
    buttons.push(
      {
        key: 3,
        label: `Refresh Grid`,
        variant: 'outlined',
        color: 'primary',
        onClick: refreshGrid,
      }
    )

    return buttons;

    // if(menuController.title?.toLowerCase() === jobApiTypes.inspections) {
    //   return [
    //     {
    //       label: `${searchParams.get(urlSearchParams.failedInspections) ? 'All Inspections' : 'Failed Only' }`,
    //       variant: 'outlined',
    //       color: `${searchParams.get(urlSearchParams.failedInspections) ? 'primary' : 'secondary' }`,
    //       onClick: toggleFailedInspections,
    //     }
    //   ];
    // }
    // return null;
  };

  const showCustomView = (customView, crudAction, isCategory = false) => {

    setCrudAction(crudAction);
    setIsCategory(isCategory);
    customView.extendedFilter = JSON.stringify(extendedFilters.applyFilters);
  
    viewController.UpdateCustomViewFilterAndSorting(customView);
    setCustomViewVisible(true);
  };

  const setNewCustomViewId = (viewId) =>{
    viewController.setNewCustomViewId(viewId);
  }


  const changeCurrentView = (customView) => {

    if (customView) {
      if (customView?.extendedFilter != "") {
        extendedFilters.setApplyFilters(JSON.parse(customView.extendedFilter));
      }  
    }
    else {
      //extendedFilters.clearFilters();
      extendedFilters.setApplyFilters({});
    }

    viewController.changeCurrentView(customView);
  };

  const closeCustomView = () => {
    setCustomViewVisible(false);
  }

  const headerComponent = <ListPageHeader headComponent = {getHeaderComponent()}
    viewController={viewController}
    extendedFilters={extendedFilters}
    totalItems={pagination.totalItemsCount}
    addHandler={()=>{navigate(allConstants.PATH.CREATE_JOB);}}
    showAddButton ={false}
    additionalButtons={getAdditionalButtons()}
    showCustomView={true} 
    createFilterForSearchText={createFilterForSearchText}
    turnOffSearch={turnOffSearch}
  >
    {pagination.ItemsController}
  </ListPageHeader>;

  const currGridProps = mergeProps(gridProps, {gridType: JobGridEnum[menuController.viewGrid].value});

  // if (!createdFromDate || !globalFilters) {
  //   return null;
  // }

  //console.log('Before Permit Jobs UI Rendered');

  return (
    // viewController.RenderElement(
    //   <>
    //     <NavBar/>
    //
    //     <ThemeProvider theme={myTheme}>
    //       <Box className={clsx(classes.page)}>
    <>
        {gotItPopup.PopUp()}
        {isLoading && <Box display='flex' justifyContent='center' alignItems='center'>
              <CircularProgress variant="indeterminate"  color="success" />
              <Typography color="red" variant="h6">
                  Please wait!
              </Typography>                
            </Box>}
      {selectedJob && !showDevJobDetails && !showDevZohoAlertHandler && <ModalWrapper
        open={true} modalName={'job-details'}
        customStyle = {{minHeight: '96%'}}
        preventScroll={!allowScrollModal}
        handleClose={handleShowJobClose} width={'90%'}
      >
        <JobDetailView jobId={selectedJob} closeModal={handleShowJobClose}
          setModalScrollable={(allow)=> {setAllowScrollModal(allow);}}/>
      </ModalWrapper>}
      {selectedJob && showDevJobDetails && <ModalWrapper open={showDevJobDetails} modalName={'job-json'}
        handleClose={devViewJobClose} width={'90%'}
        preventScroll={false}
      >
        <JobJSON jobId={selectedJob}/>
      </ModalWrapper>}
      {selectedJob && showDevZohoAlertHandler && <ModalWrapper open={showDevZohoAlertHandler} modalName={'crm-alerts'}
        handleClose={devViewJobClose} width={'90%'}
        preventScroll={false}
      >
        <DevHandleAlerts jobId={selectedJob} closeModal={devViewJobClose}/>
      </ModalWrapper>}
      {customViewVisible && 
        <ModalWrapper
          open={true} modalName={'custom-view'}
          customStyle = {{minHeight: '50%'}}
          preventScroll={true}
           width={'50%'}
        >
          <ManageCustomViews closeCustomView = {closeCustomView} customViewData={viewController.customViewData}  
                             crudAction={crudAction} isCategory={isCategory} setNewCustomViewId={setNewCustomViewId} />
        </ModalWrapper>
      }
      <DisplayListsPageWrapper
        headerComponent={headerComponent}>
        <GridWithFilterWrapper show={extendedFilters.show} filterPanel={extendedFilters.filterPanel}>
          <AllJobsGrid key={`${JobGridEnum[menuController.viewGrid].value}-${props.showNotSyncedToCRM ? 'ns' : 'all'}`}
            {...currGridProps}
            defFilterParams={defFilterParams}
            additionalFilters={extendedFilters.applyFilters}
            //globalFilters={globalFilters}
            globalSearchFilters={globalSearchFilters}
            isForContractor={false}
            showNotSyncedToCRM={props.showNotSyncedToCRM}
          />
        </GridWithFilterWrapper>
        {pagination.PageController}
      </DisplayListsPageWrapper>
    </>
    //       </Box>
    //     </ThemeProvider>
    //   </>
    // )

  );
};
export default AllPermitJobsView;
